module.exports = __webpack_public_path__ + "static/img/cover.07a0d8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_11/cover.jpg
// module id = oMLZ
// module chunks = 0